import Axios from '@/plugins/axios'
// 根据列表
export function getProcuctList (params) {
    return Axios({
        url: `/internal/product-train-admin-page`,
        method: 'post',
        data: params
    })
}

// 删除
export function deleteTrain(params) {
	return Axios({
		url: `/internal/product-train/${params.acceptid}`,
		method: 'delete'
	});
}
// 批量导出
export function exportTrain(params) {
	return Axios({
		url: `/internal/product-train-detail-list`,
		method: 'post',
		data: params
	});
}

// 获取硬件数量单位及培训方式字典
export function getDataDictionary(params) {
	return Axios({
		url: `/internal/dic-list/${params.dictype}?isinclueddelete=${params.isinclueddelete}`,
		method: 'get',
	});
}